import Modal from "@/store/components/Modal";
import Button from "@/store/components/Button";
import type { HistoryRow } from "@/store/types";

interface HistoryModalProps {
  history: HistoryRow[];
  onClose: () => void;
}

/** Scrollable purchase-history table (pinned header + footer via Modal). */
export default function HistoryModal({ history, onClose }: HistoryModalProps) {
  return (
    <Modal
      title="Purchase History"
      onClose={onClose}
      widthClassName="agd:max-w-[580px]"
      footer={
        <Button variant="ghost" onClick={onClose}>
          Close
        </Button>
      }
    >
      <table className="agd:mt-2 agd:w-full agd:border-collapse agd:text-[0.85rem]">
        <thead>
          <tr>
            <th className="agd:sticky agd:top-0 agd:z-[1] agd:border-b-2 agd:border-border agd:bg-[#f7fafc] agd:px-2.5 agd:py-2 agd:text-left agd:font-semibold agd:text-muted-foreground">
              Product
            </th>
            <th className="agd:sticky agd:top-0 agd:z-[1] agd:border-b-2 agd:border-border agd:bg-[#f7fafc] agd:px-2.5 agd:py-2 agd:text-left agd:font-semibold agd:text-muted-foreground">
              Date
            </th>
          </tr>
        </thead>
        <tbody>
          {history.length === 0 ? (
            <tr>
              <td colSpan={2} className="agd:px-2.5 agd:py-5 agd:text-center agd:text-muted-foreground">
                No history found
              </td>
            </tr>
          ) : (
            history.map((h, i) => (
              <tr key={i}>
                <td className="agd:border-b agd:border-border agd:px-2.5 agd:py-2 agd:text-foreground">
                  {h.Title ?? ""}
                </td>
                <td className="agd:whitespace-nowrap agd:border-b agd:border-border agd:px-2.5 agd:py-2 agd:text-foreground">
                  {h.CreatedOn
                    ? new Date(h.CreatedOn).toLocaleDateString("en-US", {
                        day: "numeric",
                        month: "short",
                        year: "numeric",
                      })
                    : ""}
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </Modal>
  );
}
